export default __webpack_public_path__ + "static/media/jacob.bfc182e9.jpg";